import "./SettleComponent.0.css";
import { FIT_DATA_TYPE_META, INJECT_UICORE_BUS, INJECT_UICORE_DESIGNER } from "../../lib/utils/consts";
import UcWindow from '../UcWindow';
import ListWithCatalogue from './ListWithCatalogue';
import { getPopupPosition } from "../../lib/utils/styling";
import { cloneDeep, get } from "lodash-es";
import DEFAULT_COMPONENT_ICON from '../assets/defaultComponentIcon.png';
import { getFitDataLayout } from '../utils';
import AlternativeForCompPopover from "./MaterialBox/AlternativeForCompPopover";
import { invokeFitDataOnApply } from '../designer/utils/invokeCallbacks';
const __script_base__ = {
  name: 'SettleComponent',
  components: {
    UcWindow,
    ListWithCatalogue,
    AlternativeForCompPopover
  },
  inject: {
    uc: {
      from: INJECT_UICORE_BUS
    },
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  },
  data() {
    return {
      left: '0px',
      top: '0px',
      width: '300px',
      height: '500px',
      shown: false,
      title: '',
      compPath: '',
      dataPath: '',
      currentHoveringCompForAlt: '',
      alternates: [],
      defaultIcon: DEFAULT_COMPONENT_ICON
    };
  },
  methods: {
    applyAlternateAndOpenAlternates(payload) {
      var _this$designer, _this$designer2;
      const [item] = payload;
      this.applyAlternate(...payload);
      this.designer.openCompAlternatesWindow({
        place: (_this$designer = this.designer) === null || _this$designer === void 0 || (_this$designer = _this$designer.activeCompInstance) === null || _this$designer === void 0 ? void 0 : _this$designer.$el,
        compPath: (_this$designer2 = this.designer) === null || _this$designer2 === void 0 ? void 0 : _this$designer2.compPath,
        title: (item === null || item === void 0 ? void 0 : item.name) || '未知组件',
        dataPath: this.dataPath,
        getAlternates: () => item
      });
    },
    handleMouseLeaveComp() {
      this.hoverTimeout = setTimeout(() => {
        this.currentHoveringCompForAlt = '';
      }, 500);
    },
    handleMouseEnterComp(item, index) {
      clearTimeout(this.hoverTimeout);
      this.currentHoveringCompForAlt = `${item.type}-${index}`;
    },
    getFitDataLayout(item) {
      return getFitDataLayout(item);
    },
    /**
     * @param {UICore.Designer.OpenSettleComponentOptions} options
     */
    openWindow(options) {
      var _this$options;
      const width = parseInt(this.width, 10);
      const height = parseInt(this.height, 10);
      this.title = options.title;
      const position = getPopupPosition({
        anchor: options.place,
        container: this.designer.$el,
        width,
        height
      });
      // 缓存一份配置 后面确定按钮自定义回调要用
      this.options = options;
      // 实际显示
      /** @type {IFitDataItem[]} */
      const sortedAlternates = (_this$options = this.options) !== null && _this$options !== void 0 && _this$options.getAlternates // 如果有自定义推荐组件优先采用
      ? this.options.getAlternates()
      // 否则走全量fitData
      : this.uc.fitData(options.dataPath, this.designer.renderer, {
        compTypeFilter: 'all'
      }).map(x => {
        var _FIT_DATA_TYPE_META$x;
        return {
          ...x,
          typeCName: ((_FIT_DATA_TYPE_META$x = FIT_DATA_TYPE_META[x.type]) === null || _FIT_DATA_TYPE_META$x === void 0 ? void 0 : _FIT_DATA_TYPE_META$x.name) || x.type
        };
      });
      this.left = `${position.x}px`;
      this.top = `${position.y}px`;
      this.compPath = options.compPath;
      this.dataPath = options.dataPath;
      this.alternates = sortedAlternates;
      this.shown = true;
    },
    /**
     * @param {string} key
     * @param {UICore.ComponentFitDataResult} item
     */
    matchAlternateItem(key, item) {
      const k = key.toLowerCase();
      // 这里是生成一个组件索引 用于搜索
      return [item.name, item.desc, get(item, ['layout', 'type'])].join('\n').toLowerCase().includes(k);
    },
    /**
     * @param {UICore.ComponentFitDataResult} item
     */
    async applyAlternate(item, entityParams = null) {
      // 无layout字段时尝试从layouts补充一份layout
      if (!('layout' in item) && 'layouts' in item) {
        var _layouts$;
        const {
          layouts
        } = getFitDataLayout(item);
        // eslint-disable-next-line no-param-reassign
        item = {
          ...item,
          layout: (_layouts$ = layouts[0]) === null || _layouts$ === void 0 ? void 0 : _layouts$.layout
        };
      }
      // 自定义选中组件事件
      if (this.options.applyAlternateCallback) {
        await this.options.applyAlternateCallback({
          item
        });
      } else {
        const layout = cloneDeep(item.layout);
        this.uc.completeLayout(layout); // 注意这里会直接改 layout 的哦
        this.designer.replaceCompWith(this.compPath, layout);
        this.uc.notifyPageletsChange(0);
      }
      // 清理缓存
      delete this.options;
      this.shown = false;
      this.currentHoveringCompForAlt = '';
      this.$nextTick(() => {
        invokeFitDataOnApply({
          scene: 'replace',
          uc: this.uc,
          designer: this.designer,
          renderer: this.designer.renderer,
          compPath: this.designer.compPath,
          entityParams
        }, item);
      });
    }
  },
  created() {
    // 切换子页面片，需要隐藏这个窗口！！！
    this.$watch(() => this.designer.renderer, () => {
      this.shown = false;
    });
    // 在当前窗口可见的情况下，如果选中了其他组件，要隐藏这个窗口
    this.$watch(() => this.shown && this.compPath !== this.designer.compPath, needClosing => {
      if (needClosing) this.shown = false;
    });
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("uc-window", {
    attrs: {
      left: _vm.left,
      top: _vm.top,
      width: _vm.width,
      title: _vm.title,
      visible: _vm.shown
    },
    on: {
      "update:visible": function ($event) {
        _vm.shown = $event;
      }
    }
  }, [_c("div", {
    staticClass: "ucd-settleComponent"
  }, [_c("ListWithCatalogue", {
    ref: "listWithCatalogue",
    staticClass: "ucd-settleComponent-list",
    style: "height: " + _vm.height,
    attrs: {
      data: _vm.alternates,
      "category-key": "typeCName",
      "show-search": "",
      "search-placeholder": "搜索组件",
      "filter-function": _vm.matchAlternateItem
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (ref) {
        var item = ref.item;
        var index = ref.index;
        return [_c("div", {
          key: index,
          ref: item.type + "-" + index,
          staticClass: "ucd-settleComponent-item",
          attrs: {
            title: item.name,
            tabindex: ""
          },
          on: {
            click: function ($event) {
              return _vm.applyAlternate(item);
            },
            mouseenter: function ($event) {
              return _vm.handleMouseEnterComp(item, index);
            }
          }
        }, [_c("img", {
          staticClass: "ucd-settleComponent-itemIcon",
          attrs: {
            src: item.icon || _vm.defaultIcon
          }
        }), _vm._v(" "), _c("div", {
          staticClass: "ucd-settleComponent-itemTitle"
        }, [_vm._v("\n            " + _vm._s(item.name) + "\n          ")]), _vm._v(" "), _vm.getFitDataLayout(item).layouts.length ? _c("a-icon", {
          attrs: {
            type: "caret-right"
          }
        }) : _vm._e(), _vm._v(" "), _vm.currentHoveringCompForAlt === item.type + "-" + index && _vm.getFitDataLayout(item).layouts.length ? _c("AlternativeForCompPopover", {
          attrs: {
            value: item
          },
          on: {
            mouseleave: _vm.handleMouseLeaveComp,
            switch: function (payload) {
              return _vm.applyAlternateAndOpenAlternates(payload);
            }
          }
        }) : _vm._e()], 1)];
      }
    }])
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/SettleComponent.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);